export const api = `${process.env.REACT_APP_API}/api/`;
